import React from 'react';
import { Box, Button, Typography } from '@mui/material';

const COPY = {
  pending: {
    title: 'Cadastro aguardando aprovação',
    message: 'Seu cadastro foi recebido com sucesso. Um administrador precisa aprovar seu acesso antes que você possa utilizar o PontoNow. Após a aprovação, entre novamente com esta mesma conta Google.',
  },
  rejected: {
    title: 'Acesso não aprovado',
    message: 'Seu cadastro não está autorizado a acessar o PontoNow. Se precisar de acesso, entre em contato com o administrador responsável.',
  },
};

export default function AccountAccessNotice({ kind, email, onBack }) {
  const copy = COPY[kind] || COPY.pending;
  return (
    <Box sx={{ width: '100%', maxWidth: 480, mx: 'auto' }}>
      <Typography variant="h5" component="h2" sx={{ mb: 1.5 }}>
        {copy.title}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {copy.message}
      </Typography>
      {email ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, wordBreak: 'break-word' }}>
          {email}
        </Typography>
      ) : null}
      <Button variant="contained" onClick={onBack} fullWidth>
        Voltar para o login
      </Button>
    </Box>
  );
}
